// src/components/LoadingSpinner.js
import React from "react";

const LoadingSpinner = ({ className = "border-blue-500", size = "w-6 h-6" }) => (
  <div
    className={`${size} animate-spin rounded-full border-2 ${className} border-t-transparent`}
  ></div>
);

export default LoadingSpinner;
